<template>
    <div style="position: relative">   
        <div>
            <v-container
                class="px-0"
                fluid
            >
                <v-btn @click="callAPI">Call API</v-btn>  

                
                <validation-observer
                    ref="observer"
                    v-slot="{ invalid }"
                >  
                    <form @submit.prevent="submit">        
                        
                        <validation-provider
                            v-slot="{ errors }"
                            name="acceptWatcher"
                            rules="required"
                        >         
                            <v-radio-group v-model="radioGroup">
                                <v-radio
                                    v-for="(member, key) in newMembers"
                                    v-bind:key="key"
                                    :label="member.name"
                                >
                                    <template v-slot:label>
                                        <v-list-item>
                                            <v-list-item-avatar>
                                                <v-img v-bind:src="member.avatar_image_url"></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{member.name}}</v-list-item-title>
                                                <v-list-item-subtitle>{{member.account_id}}</v-list-item-subtitle>
                                                <v-list-item-subtitle>{{member.message}}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                            <span><font color="red"> {{ errors[0] }}</font></span>
                        </validation-provider>

                        <div class="mt-4">
                            <v-btn
                                v-if="newMembers.length>0"
                                class="mr-4"
                                type="submit"
                                :disabled="invalid"
                            >
                                承認する
                            </v-btn>
                        </div>


                        <v-alert
                            type="error"
                            prominent
                            border="left"
                        >
                        自分が担当した人だけを承認するようにしてください。知らない人を承認してしまうと、ICと無関係の人がグループチャットに入ってしまうので
                        安心安全が脅かされれしまいます。もし、間違った人を承認してしまった場合は、速やかに連絡してください。
                        </v-alert>
                    </form>
                </validation-observer>
            </v-container>
        </div>
        
    </div>
</template>



<script>
    import { required } from "vee-validate/dist/rules";
    import { mapGetters } from "vuex";
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode  } from "vee-validate";
    import axios from 'axios';

    const LOCAL_GET_NEW_CONTACT = 'http://localhost:5001/seminar-app-e5eb3/us-central1/helloWorld?env=local';
    const PROD_GET_NEW_CONTACT = 'https://us-central1-seminar-app-e5eb3.cloudfunctions.net/helloWorld';
    const LOCAL_APPROVE = 'http://localhost:5001/seminar-app-e5eb3/us-central1/approveContact?env=local';
    const PROD_APPROVE = 'https://us-central1-seminar-app-e5eb3.cloudfunctions.net/approveContact';

    setInteractionMode("eager");

    extend("required", {
        ...required,
        message: "入力してください",
    });


    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },


        data() {
            return {
                // newMembers : [{name:'1'},{name:'2'},{name:'3'}]
                newMembers:[],
                radioGroup: 1,
                invalid : false,
                
            };
        },


        methods:{
            callAPI(){
                //セールス担当の場合
                if(this.role.sales){
                    //環境チェック（本番orLocal）
                    const url = (location.hostname == 'localhost')?LOCAL_GET_NEW_CONTACT:PROD_GET_NEW_CONTACT;

                    // var test = this.newMembers;

                    //API Call
                    axios.get(url)
                    .then(response => {
                        this.newMembers = response.data
                        console.log(this.newMembers)
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    });
                    
                }

            },
            submit () {
                //データのバリデーション
                this.$refs.observer.validate();

                
                const url = (location.hostname == 'localhost')?LOCAL_APPROVE:PROD_APPROVE;
                //API Call
                axios.get(url)
                .then(response => {
                    console.log(response)
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally(function () {
                    // always executed
                });
            },
        },

        computed:{
            ...mapGetters(['role', 'login_user', 'uid', 'users_info']),

            
        }
    };
  
</script>

<style scoped lang="scss">
a{
    text-decoration :none;
}
</style>